function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2D2D2D",
  fillRule: "nonzero",
  d: "M16.48 6.88H8.4V4.8c0-1.6 1.28-2.96 2.96-2.96h1.04c1.2 0 2.24.72 2.72 1.76.16.4.64.56 1.04.4.4-.16.56-.64.4-1.04-.72-1.68-2.32-2.8-4.16-2.8h-1.04c-2.48 0-4.56 2-4.56 4.56v2.16c-1.84.32-3.28 2-3.28 3.92v8.88c0 2.24 1.76 4 4 4h8.88c2.24 0 4-1.76 4-4v-8.8c.08-2.24-1.76-4-3.92-4zm2.4 12.88c0 1.36-1.04 2.4-2.4 2.4H7.52c-1.36 0-2.4-1.04-2.4-2.4v-8.88c0-1.36 1.04-2.4 2.4-2.4h8.88c1.36 0 2.4 1.04 2.4 2.4v8.88h.08zM13.2 14c0 .32-.16.64-.4.88v1.84c0 .48-.32.8-.8.8-.48 0-.8-.32-.8-.8v-1.84c-.24-.24-.4-.56-.4-.88 0-.64.56-1.2 1.2-1.2.64 0 1.2.56 1.2 1.2z"
});

var SvgPasswordIcon24Px = function SvgPasswordIcon24Px(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 25
  }, props), _ref);
};

export default SvgPasswordIcon24Px;